/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './style.scss';
import { Spin } from 'antd';
import Helpers from '@Apis/helpers';
import AnalyticsActions from '@Actions/application/analyticsActions';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import confetti from '@Images/icons/confetti.png';
/**
 *
 */
function ActivityCalendar({
  data, selectedTenant, getAnalyticsData, user,
}) {
  const [currentDay, setCurrentDay] = useState(new Date());
  const [tenantIds, setTenantIds] = useState();

  useEffect(() => {
    if (selectedTenant?.length > 0) {
      getAnalyticsData('PURCHASE', 'PURCHASE_SCHEDULE', {
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        startDate: dayjs(currentDay).format('YYYY-MM-DD'),
        endDate: dayjs(currentDay).format('YYYY-MM-DD'),
        groupType: 'DAILY',
      });
      setTenantIds(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','));
    }
  }, [currentDay, selectedTenant]);

  const getDay = (day) => {
    if (day === 0) return 'SUN';
    if (day === 1) return 'MON';
    if (day === 2) return 'TUE';
    if (day === 3) return 'WED';
    if (day === 4) return 'THU';
    if (day === 5) return 'FRI';
    if (day === 6) return 'SAT';
    return '';
  };

  const getDayDocument = (day) => data?.data?.po_data?.find((rec) => dayjs(rec?.day)?.format('YYYY-MM-DD') === dayjs(day).format('YYYY-MM-DD'));
  const getDayGrnDocument = (day) => data?.data?.grn_data?.find((rec) => dayjs(rec?.day)?.format('YYYY-MM-DD') === dayjs(day).format('YYYY-MM-DD'));

  return (
    <div className="activity-calendar__wrapper">
      {data?.loading && (
        <div className="widget-loader">
          <Spin />
        </div>
      )}
      <div className="activity-calendar">
        <div className="activity-calendar__header">
          <H3Text text="Today's Schedule" className="activity-calendar__title" />
          <div className="activity-calendar__changer">
            <div
              className="activity-calendar__changer-prev"
              onClick={() => {
                if (!data?.loading) {
                  setCurrentDay(new Date(currentDay.setDate(currentDay.getDate() - 1)));
                }
              }}
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </div>
            <div
              className="activity-calendar__changer-next"
              onClick={() => {
                if (!data?.loading) {
                  setCurrentDay(new Date(currentDay.setDate(currentDay.getDate() + 1)));
                }
              }}
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </div>
          </div>
        </div>
        <div className="activity-section__wrapper">
          <div className="activity-section">
            <div className="activity-section__day">
              {getDay(dayjs(currentDay).day())}
            </div>
            <div className="activity-section__date">
              <H3Text text={dayjs(currentDay).format('DD')} className="activity-section__date-date" />
              <H3Text text={dayjs(currentDay).format('MMM')?.toUpperCase()} className="activity-section__date-month" />
            </div>
            <div className="activity-section__summary">
              {
                !data?.data?.po_data?.find((rec) => dayjs(rec?.day)?.format('YYYY-MM-DD') === dayjs(currentDay).format('YYYY-MM-DD'))
                  && !data?.data?.grn_data?.find((rec) => dayjs(rec?.day)?.format('YYYY-MM-DD') === dayjs(currentDay).format('YYYY-MM-DD'))
                  && (
                    <div className="activity-calendar__loader">
                      <H3Image src={confetti} className="activity-calendar__loader-image" />
                      <H3Text text="No Scheduled Orders" className="activity-calendar__loader-text" />
                    </div>
                  )
              }
              {
                  data?.data?.po_data?.find((rec) => dayjs(rec?.day)?.format('YYYY-MM-DD') === dayjs(currentDay).format('YYYY-MM-DD'))
                  && (
                    <div
                      className="activity-section__summary-purchase"
                      onClick={() => window.open(Helpers.appendSystemDefaultFilterIdInURL(`purchase/purchase-orders?page=1&limit=10&tenant=${tenantIds}&status=ISSUED&edd=${dayjs(currentDay).format('YYYY-MM-DD')}`))}
                      style={{
                        cursor: 'pointer',
                      }}

                    >
                      <div
                        className="activity-section__summary-purchase-status"

                      />
                      <H3Text text={`${getDayDocument(currentDay)?.po_count} Deliveries Scheduled`} className="" />
                    </div>
                  )
              }
              {
                  data?.data?.grn_data?.find((rec) => dayjs(rec?.day)?.format('YYYY-MM-DD') === dayjs(currentDay).format('YYYY-MM-DD'))
                  && (
                    <div
                      className="activity-section__summary-purchase"
                      onClick={() => window.open(Helpers.appendSystemDefaultFilterIdInURL(`purchase/goods-receiving?page=1&limit=10&status=ISSUED&schedule_grn=true&tenant=${tenantIds}&from_grn_due_date=${dayjs(currentDay).format('YYYY-MM-DD')}&to_grn_due_date=${dayjs(currentDay).format('YYYY-MM-DD')}`))}
                      style={{
                        cursor: 'pointer',
                      }}
                    >
                      <div className="activity-section__summary-purchase-status" />
                      <H3Text text={`${getDayGrnDocument(currentDay)?.grn_count} Deliveries Done`} className="" />
                    </div>
                  )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (dispatch) => ({
  getAnalyticsData: (dataType, name, params) => dispatch(AnalyticsActions.getAnalyticsData(dataType, name, params)),
});

ActivityCalendar.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
  selectedTenant: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ActivityCalendar));
